import React from "react";
import clsx from "clsx";
import LanguageSelector from "./LanguageSelector";
import BusinessCardFooter from "./BusinessCardFooter";

interface EndUserPublicLayoutProps {
  entityLogo?: string | null;
  entityName?: string | null;
  title?: string;
  subtitle?: string;
  media?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  showFooter?: boolean;
}

const EndUserPublicLayout: React.FC<EndUserPublicLayoutProps> = ({
  entityLogo,
  entityName,
  title,
  subtitle,
  media,
  children,
  className,
  showFooter = true,
}) => {
  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div
          className={clsx(
            "w-full max-w-md flex flex-col items-stretch gap-6",
            className
          )}
        >
          {(entityLogo || entityName) && (
            <div className="flex flex-col items-center gap-2">
              {entityLogo && (
                <img
                  src={entityLogo}
                  alt={entityName || "Logo"}
                  className="w-14 h-14 rounded-full object-cover border border-gray-200 shadow-sm bg-white"
                />
              )}
              {entityName && (
                <div className="text-gray-900 text-lg font-semibold font-figtree leading-7 text-center">
                  {entityName}
                </div>
              )}
            </div>
          )}

          <div className="relative bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col">
            <div className="absolute top-2 end-2 z-10">
              <LanguageSelector variant="compact" />
            </div>

            <div className="p-6 pt-12 sm:p-8 sm:pt-12 flex flex-col gap-6">
              {media}
              {(title || subtitle) && (
                <div className="flex flex-col items-center gap-1 text-center">
                  {title && (
                    <h1 className="text-gray-900 text-2xl font-bold font-figtree leading-8">
                      {title}
                    </h1>
                  )}
                  {subtitle && (
                    <p className="text-gray-500 text-sm font-normal font-figtree leading-tight">
                      {subtitle}
                    </p>
                  )}
                </div>
              )}

              {children}
            </div>

            <BusinessCardFooter showFooter={showFooter} theme="default" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EndUserPublicLayout;
